import { InputHTMLAttributes } from 'react';
import { useFormContext } from 'react-hook-form';
import clsx from 'clsx';

interface TextFieldProps extends InputHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  containerClass?: string;
  isOptional?: boolean;
  boldLabel?: boolean;
}

export const TextField = ({
  name,
  label,
  containerClass,
  isOptional,
  boldLabel,
  ...rest
}: TextFieldProps) => {
  const {
    register,
    // @ts-expect-error this are need to update the input state on errors/etc
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    formState: { errors, isDirty },
  } = useFormContext();

  return (
    <div className={`w-full relative ${containerClass ?? ''}`}>
      {label && (
        <label htmlFor={name} className={clsx("inline-block mb-1", boldLabel ? "text-lg font-bold" : "text-sm font-medium")}>
          {label}{' '}
          {isOptional && <span className="text-base-coolGray">(Optional)</span>}
        </label>
      )}
      <textarea
        {...rest}
        {...register(name ?? '')}
        rows={5}
        maxLength={rest.maxLength}
        className={clsx(
          `bg-base-seasalt rounded py-3 px-4 w-full outline-brand-baseBlue outline-1 ${rest.className ?? ''}`,
          { 'border border-system-error': name && errors[name] }
        )}
      />

      {name && errors[name] && (
        <p role="alert" className="text-system-error text-sm text-left pt-1">
          {typeof errors?.[name]?.message === 'string'
            ? errors[name]?.message
            : ''}
        </p>
      )}
    </div>
  );
};
